import React, {Component} from "react";
import ReactDOM from "react-dom";
import Form from "./Form";
import Table from "./Table";


class Index extends Component {
    state = {
        user_type: [],
        age: [],
        genre: null,
        marital_status: null,
        children: null,
        income: 0,

        data: [],
        excelFile: '',
        errors: [],
    };

    componentDidMount = async () => {
        this.getData();
        this.getExcelFile();
    };

    handleChanged = async (event) => {
        if (Array.isArray(event.value) && event.name != "age") {
            event.value = event.value.map((index) => {
                return index.value;
            });
        }

        await this.setState({
            [event.name]: event.value,
        });
    };

getData = async () => {
    this.setState({ data: [], errors: null });

    const filters = {
        user_type: this.state.user_type,
        age: this.state.age,
        genre: this.state.genre,
        marital_status: this.state.marital_status,
        children: this.state.children,
        city: this.state.city,
        location: this.state.location,
        circle: this.state.circle,
    };

    try {
        const response = await axios.get(
            "/geo-referenciamento/list",
            { params: filters }
        );

        this.setState({ data: response.data });

    } catch (error) {
     
        if (error.response?.status === 422) {
            this.setState({
                errors: error.response.data.errors
            });
            return;
        }

        console.error("Erro ao buscar dados:", error);

        this.setState({
            errors: {
                general: ['Erro inesperado ao buscar os dados. Tente novamente.']
            }
        });
    }
};



    getExcelFile = async () => {
        await this.setState({
            excelFile: '',
        })

        axios
            .get(
                "/geo-referenciamento/excelFile"
            )
            .then((response) => {
                this.setState({
                    excelFile: response.data,
                });
            })
            .catch((error) => { });
    }

    render() {
        return (
            <>
                <Form
                    handleChanged={this.handleChanged}
                    getData={this.getData}
                    state={this.state}
                />
                <Table data={this.state.data} getData={this.getData} />
            </>
        );
    };
}



if (document.getElementById("geo_referenciamento")) {
    ReactDOM.render(<Index />, document.getElementById("geo_referenciamento"));
}

export default Index;
